import React from "react";

import { useGranite } from "@redux/modules/value/translations/translations.provider";

import { Button } from "@components/General/Button/button.component";

type Props = {
    promotions: Array<{ code: string; type: string }>;
    removePromotionCode: (code: string) => void;
};

export const PromotionList = ({ promotions, removePromotionCode }: Props) => {
    const { t } = useGranite();

    const ActiveDiscount = ({ code, onClick }: any) => (
        <div className="m-0 p-0">
            <span className="text-uppercase">{code}</span>
            <Button
                onClick={onClick}
                className="m-0 p-0 ml-2 align-baseline"
                type="button"
                color="link"
                aria-label={t("general.button.delete")}
            >
                <i className="las la-trash" />
            </Button>
        </div>
    );

    if (promotions.length === 0) {
        return null;
    }

    return (
        <div className="discount-list pt-sm-2 pt-md-0">
            <h6 className="discount-title font-weight-bold">
                {t("general.checkout.discount.label.activeDiscounts")}
            </h6>
            <div>
                {promotions.map((promotion, index) => (
                    <ActiveDiscount
                        key={index}
                        code={promotion.code}
                        onClick={() => removePromotionCode(promotion.code)}
                    />
                ))}
            </div>
        </div>
    );
};
